import { render, staticRenderFns } from "./_MedicalAssessmentSection.vue?vue&type=template&id=10b9cb48"
import script from "./_MedicalAssessmentSection.vue?vue&type=script&lang=ts"
export * from "./_MedicalAssessmentSection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/components/organs/shared/_locales/_MedicalAssessmentSection.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fcomponents%2Forgans%2Fshared%2F_MedicalAssessmentSection.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports